<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <filter id="filter-1">
      <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.431373 0 0 0 0 0.258824 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
    </filter>
    <filter id="filter-2">
      <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
    </filter>
  </defs>
  <g id="Signup" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="checkmark" transform="translate(-50.000000, -15.000000)" filter="url(#filter-1)">
      <g transform="translate(50.000000, 15.000000)" id="Color" filter="url(#filter-2)">
        <g transform="translate(0.000000, 2.045455)">
          <polygon id="Path" fill="#FFFFFF" points="6.19374045 13.7906317 18 1.98433008 16.015684 0 6.19374045 9.82195753 1.98433008 5.61254716 0 7.59687724"></polygon>
        </g>
      </g>
    </g>
  </g>
</svg>
